import React, { useState, useMemo } from 'react';
import { Container, Row, Col, Form, Dropdown, Card } from 'react-bootstrap';
import { ChevronDown, FileSpreadsheet, FileText, FileImage, FileType } from 'lucide-react';
import { FaSearch } from "react-icons/fa";
import '../../Styles/yellowcalfcss/PaidBills.css';

const mockData = [ 
  { id: 1, billNumber: 'cgfhgjhjh', supplier: '', billDate: '2022-03-03', dueDate: '2022-03-10', totalAmount: 268 },
  { id: 2, billNumber: '12112', supplier: '', billDate: '2022-03-21', dueDate: '2022-03-22', totalAmount: 262 },
  { id: 3, billNumber: 'new bill', supplier: '', billDate: '2022-01-25', dueDate: '2022-03-27', totalAmount: 260 },
  { id: 4, billNumber: '1712', supplier: '', billDate: '2022-03-01', dueDate: '2022-03-02', totalAmount: 252 },
  { id: 5, billNumber: '123456', supplier: '', billDate: '2022-04-01', dueDate: '2022-04-22', totalAmount: 75 },
  { id: 6, billNumber: '35523', supplier: '', billDate: '2022-05-06', dueDate: '2022-05-12', totalAmount: 32 },
  { id: 7, billNumber: '33612', supplier: '', billDate: '2022-07-12', dueDate: '2022-07-13', totalAmount: 115 },
  { id: 8, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 120 },
  { id: 9, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 10, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 11, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 12, billNumber: 'www222', supplier: '', billDate: '2024-04-05', dueDate: '2024-04-14', totalAmount: 0 },
  { id: 13, billNumber: 'www222', supplier: '', billDate: '2024-04-30', dueDate: '2024-04-14', totalAmount: 120 }
];

export function PaidBills() {
  const [filters, setFilters] = useState({
    billNumber: '',
    supplier: '',
    billDate: '',
    dueDate: '',
    totalAmount: ''
  });

  const filteredData = useMemo(() => {
    return mockData.filter(b =>
      b.billNumber.toLowerCase().includes(filters.billNumber.toLowerCase()) &&
      b.supplier.toLowerCase().includes(filters.supplier.toLowerCase()) &&
      b.billDate.includes(filters.billDate) &&
      b.dueDate.includes(filters.dueDate) &&
      b.totalAmount.toString().includes(filters.totalAmount)
    );
  }, [filters]);

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="financial-billing-main-area">
      <div className="billing-content-organizer">

        <div className="spacing-unit-container">
          <Card className="title-display-module">
            <Card.Body>
              <h3 className="primary-heading-text">Paid Bills</h3>
            </Card.Body>
          </Card>
        </div>


        <div className="spacing-unit-container">
          <Row>
            <Col md={6} style={{ width: '250px', marginTop: '-10px' }}>
              <div style={{ position: "relative" }}>
                <FaSearch
                  style={{
                    marginTop: "0px",
                    marginLeft: "-20px",
                    position: "absolute",
                    top: "50%",
                    left: "12px",
                    transform: "translateY(-50%)",
                    color: "#999",
                    fontSize: "14px"
                  }}
                />
                <Form.Control
                  type="text"
                  placeholder="Bill Number"
                  value={filters.billNumber}
                  onChange={e => handleFilterChange('billNumber', e.target.value)}
                  className="transparent-search-field"
                  style={{ paddingLeft: "35px" }}
                />
              </div>
            </Col>


            <Col md={6} style={{ width: '250px', marginTop: '-10px' }}>
              <div style={{ position: "relative" }}>
                <FaSearch
                  style={{
                     marginLeft: "-20px",
                    position: "absolute",
                    top: "50%",
                    left: "12px",
                    transform: "translateY(-50%)",
                    color: "#999",
                    fontSize: "14px"
                  }}
                />
                <Form.Control
                  type="text"
                  placeholder="Bill Date"
                  value={filters.billDate}
                  onChange={e => handleFilterChange('billDate', e.target.value)}
                  className="transparent-search-field"
                  style={{ paddingLeft: "35px" }}
                />
              </div>
            </Col>
          </Row>
        </div>

        {/* TABLE */}
        <div className="spacing-unit-container">
          <div className="table-data-collection">

            <Card className="header-definition-card table-row-spacing" style={{marginTop:'8px'}}>
              <Card.Body style={{height:'60px'}}>
                <Row style={{marginTop:'4px'}}>
                  <Col md={1} style={{ textAlign: 'center', marginLeft: '18px' }}>Sr No</Col>
                  <Col md={2} style={{ textAlign: 'center' }}>Bill Number</Col>
                  <Col md={2} style={{ textAlign: 'center' }}>Supplier</Col>
                  <Col md={2} style={{ textAlign: 'center' }}>Bill Date</Col>
                  <Col md={2} style={{ textAlign: 'center', marginLeft: '65px' }}>Due Date</Col>
                  <Col md={2} style={{ textAlign: 'center' }}>Total Amount</Col>
                  <Col md={1}></Col>
                </Row>
              </Card.Body>
            </Card>

            {filteredData.map(bill => (
              <Card key={bill.id} className="record-display-card table-row-spacing">
                <Card.Body style={{height:"45px"}}>
                  <Row style={{marginTop:"-4px" , gap:"7px" , fontSize:"14px"}}>
                    <Col md={1} style={{ textAlign: 'center', marginLeft: '10px' }}>{bill.id}</Col>
                    <Col md={2} style={{ textAlign: 'center' }}>{bill.billNumber}</Col>
                    <Col md={2} style={{ textAlign: 'center' }}>{bill.supplier || '-'}</Col>
                    <Col md={2} style={{ textAlign: 'center' }}>{bill.billDate}</Col>
                    <Col md={2} style={{ textAlign: 'center' , marginLeft: '50px' }}>{bill.dueDate}</Col>
                    <Col md={2} style={{ textAlign: 'center' }}>
                      {bill.totalAmount === 0 ? '0' : `$ ${bill.totalAmount}`}
                    </Col>
                    <Col md={1}></Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}

          </div>
        </div>

      </div>
    </div>
  );
}
